export default function (field) {
  return function (item) {
    if (!field || !item) {
      return null;
    }

    if (field.required) {
      if (!(field.code in item)) {
        return "required";
      } else {
        const val = item[field.code];
        var isNull = val === null;

        const isUndefined = val === undefined;
        const isZeroLen = val !== null && val.length === 0;

        if (field.params && field.params.allow_na === true) {
          // This field has allow_na ticked so `null` is a valid value here
          isNull = false; // Ignore null as this is valid Value when allow NA
        }
        if (isNull || isUndefined || isZeroLen) {
          return "required";
        }
      }
    }

    return null;
  };
}
